/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Formik, Form } from 'formik';
import { gql, useMutation } from '@apollo/client';
import { Box, Flex, Button, useToast, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, Grid, GridItem } from '@chakra-ui/react';
import TextFormField from '../../components/form/TextFormField';
import DateFormField from '../form/DateFormField';
import CheckBoxFormField from '../../components/form/CheckBoxFormField';
import MultipleFileFormField from '../form/MultipleFileFormField';
import c from '../../constant';
import * as Yup from 'yup';

const M_CREATE_CERTIFICTE = gql`
	mutation create(
		$geoLocation: String
		$isGeoManual: Boolean
		$geoManual: String
		$validTo: DateTime
		$validFrom: DateTime
		$name: String!
		$nameLatin: String
		$managerName: String
		$managerNameLatin: String
		$number: String
		$companyID: String!
		$isPermanentLicense: Boolean
		$companyCertificateType: String
		$files: JSON
	) {
		createCompanyCertificate(
			geoLocation: $geoLocation
			isGeoManual: $isGeoManual
			geoManual: $geoManual
			validTo: $validTo
			validFrom: $validFrom
			name: $name
			nameLatin: $nameLatin
			managerName: $managerName
			managerNameLatin: $managerNameLatin
			number: $number
			companyID: $companyID
			isPermanentLicense: $isPermanentLicense
			companyCertificateType: $companyCertificateType
			files: $files
		)
	}
`;

const validationSchema = Yup.object().shape({
	number: Yup.string().nullable(),
	name: Yup.string().required('required'),
	isPermanentLicense: Yup.boolean().nullable(),
	validFrom: Yup.string().nullable(),
	validTo: Yup.string().nullable(),
	files: Yup.array().of(
		Yup.object().shape({
			tempFile: Yup.mixed().test('fileSize', 'required', (value) => {
				return value ? true : false;
			}),
		})
	),
});

function AddCompanyRegisteredOfficeModal({ companyId, isOpen = false, onClose = () => null, callback = () => null }) {
	const toast = useToast();
	const { t } = useTranslation();
	const [isPermanentLicense, setPermanentLicense] = useState(false);
	const [createCertificate, { loading, error, data }] = useMutation(M_CREATE_CERTIFICTE);

	useEffect(() => {
		if (data) {
			if (data) {
				toast({
					title: t('Registered office created successfully'),
					status: 'success',
					isClosable: true,
					position: 'top-right',
				});
				onClose();
				callback('Registered office created successfully');
			}
		}
	}, [data]);

	useEffect(() => {
		if (error) {
			error.graphQLErrors.map(({ message }, i) =>
				toast({
					title: t(message),
					status: 'error',
					isClosable: true,
					position: 'top-right',
				})
			);
		}
	}, [error]);

	return (
		<>
			<Modal isOpen={isOpen} onClose={onClose} size="xl">
				<ModalOverlay />
				<ModalContent borderRadius={c.borderRadius} pb={4}>
					<ModalHeader>{t('Add Company Registered Office')}</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<Formik
							validationSchema={validationSchema}
							initialValues={{
								number: '',
								name: '',
								nameLatin: '',
								managerName: '',
								managerNameLatin: '',
								geoLocation: null,
								isGeoManual: false,
								geoManual: '',
								validFrom: null,
								validTo: null,
								files: [],
								isPermanentLicense: false,
							}}
							onSubmit={(values) => {
								const variables = {
									companyCertificateType: 'r',
									companyID: companyId,
									number: values?.number,
									name: values?.name,
									nameLatin: values?.nameLatin,
									managerName: values?.managerName,
									managerNameLatin: values?.managerNameLatin,
									geoLocation: JSON.stringify(values?.geoLocation),
									isGeoManual: values?.isGeoManual,
									geoManual: values?.geoManual,
									validTo: values?.validTo,
									validFrom: values?.validFrom,
									isPermanentLicense: values?.isPermanentLicense,
									files: values?.files,
								};
								createCertificate({ variables });
							}}
						>
							{(props) => (
								<Form>
									<Box mt="3">
										<Grid templateColumns="repeat(1, 1fr)" gap={6}>
											<GridItem w="100%">
												<TextFormField {...props} label="Number" name="number" />
												<TextFormField {...props} label="Name" name="name" required />
												<MultipleFileFormField name="files" label="Files" />
												<CheckBoxFormField
													{...props}
													label="Is Permanent License"
													name="isPermanentLicense"
													callbackValueChange={(e) => setPermanentLicense(e)}
												/>
												{!isPermanentLicense && (
													<Grid templateColumns="repeat(2, 1fr)" gap={6}>
														<GridItem w="100%">
															<DateFormField name="validFrom" label="Valid From" />
														</GridItem>
														<GridItem w="100%">
															<DateFormField name="validTo" label="Valid To" />
														</GridItem>
													</Grid>
												)}
											</GridItem>
										</Grid>
										<Flex textAlign="right" mt="6" justifyContent="space-between" alignItems="center" float="right">
											<Button
												id="login-btn"
												variant="solid"
												size="md"
												h="42px"
												w="128px"
												bg="primary.dark"
												_hover={{ bg: 'primary.dark' }}
												color="white"
												type="submit"
												isLoading={loading}
												loadingText={t('Add')}
												spinnerPlacement="start"
											>
												{t(`Add`)}
											</Button>
										</Flex>
									</Box>
								</Form>
							)}
						</Formik>
					</ModalBody>
				</ModalContent>
			</Modal>
		</>
	);
}

export default AddCompanyRegisteredOfficeModal;
